import { z } from 'zod';
import { optionalMongoObjectId } from './object-id-helpers.js';

export const CreatePendingChangeSchema = z.object({
    pageKey: z.string().min(1),
    resourceType: z.string().min(1),
    operation: z.enum(['create', 'update', 'delete']),
    resourceId: z.string().optional(),
    resourceName: z.string().optional(),
    payload: z.any(),
    previousData: z.any().optional(),
    assignmentTemplate: z.string().min(1)
});

export const ApprovalActionSchema = z.object({
    comments: z.string().optional(),
    signature: z.object({
        fileUrl: z.string().optional(),
        ip: z.string().optional(),
        userAgent: z.string().optional()
    }).optional()
});

export const ResubmitSchema = z.object({
    payload: z.any()
});

/**
 * Extra fields on HTTP 202 responses when page-approval intercepts Action create/update (Rule B draft).
 * Prefer loose strings for client compatibility (lean DTOs).
 */
export const ActionApprovalIntercept202Schema = z.object({
    pendingChangeId: optionalMongoObjectId,
    approvalStatus: z.string().optional(),
    message: z.string().optional(),
    merged: z.boolean().optional(),
    restarted: z.boolean().optional(),
    draftExecutionTicketId: optionalMongoObjectId
});

/**
 * Successful manual or idempotent execution draft under a PendingChange row.
 */
export const PendingChangeExecutionDraftResultSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    data: z.object({
        pendingChangeId: optionalMongoObjectId,
        draftExecutionTicketId: optionalMongoObjectId,
        idempotent: z.boolean().optional()
    }).optional()
});
